import { call, put, takeLatest } from "redux-saga/effects";
import {
    onValidateLoginTokenSubmit, onValidateLoginTokenSuccess, onValidateLoginTokenError, onEnrolledSubmit, onEnrolledSuccess, onEnrolledError
} from "../Store/Slices/validateLoginTokenSlice";
import { enrollmentApi } from "../Context/EnrolledApi";
import { validateLoginTokenApi } from "../Context/validateLoginTokenApi";


function* validateLoginToken({ payload }) {
    try {
        const loginTokenResponseData = yield call(validateLoginTokenApi, payload);
        // Client API follows the standard GiftStacc envelope. Its response holds
        // the unchanged Validate Login Token integration response.
        const validateLoginTokenResponse =
            loginTokenResponseData?.response || loginTokenResponseData;

        if (validateLoginTokenResponse.responseCode === "200") {
            const response = validateLoginTokenResponse.response || {};
            // Validate Login Token responses differ between integration versions:
            // some return memberProfile, while others return the same profile
            // fields at the response root. Keep the complete response and expose
            // the shape already consumed throughout the existing UI.
            const memberProfile = response.memberProfile || {
                firstName: response.firstName,
                lastName: response.lastName,
                mobileNumber: response.mobileNumber,
                emailId: response.emailId,
                title: response.title,
                titleDescription: response.titleDescription,
                gender: response.gender,
                genderDescription: response.genderDescription,
                dob: response.dob,
                maritalStatus: response.maritalStatus,
                maritalStatusDescription: response.maritalStatusDescription,
                address: response.address,
            };
            yield put(
                onValidateLoginTokenSuccess({
                    data: { ...response, memberProfile },
                    status_code: validateLoginTokenResponse.responseCode,
                })
            );
        } else {
            yield put(
                onValidateLoginTokenError({
                    data: validateLoginTokenResponse.response,
                    message: validateLoginTokenResponse.responseMessage || "Invalid Credentials.",
                    status_code: String(validateLoginTokenResponse.responseCode || 401),
                })
            );
        }
    } catch (error) {
        // Gateway/Client API returns authentication failures as a real HTTP 401,
        // so Axios rejects the promise. Always finish the Redux loading state.
        const responseData = error?.response?.data;
        const response =
            responseData && typeof responseData === "object" ? responseData : {};
        const statusCode = String(
            error?.response?.status ||
            response.httpStatusCode ||
            response.responseCode ||
            500
        );
        const message =
            response.errorMessage ||
            response.responseMessage ||
            error?.message ||
            "Unable to validate the login session.";

        yield put(onValidateLoginTokenError({
            data: response.response || {},
            message,
            status_code: statusCode,
        }));
    }
}
function* Enrolled({ payload }) {

    try {
        const enrolledResponseData = yield call(enrollmentApi, payload);
        if (enrolledResponseData.responseCode === "200") {
            yield put(
                onEnrolledSuccess({
                    enrolledData: enrolledResponseData.response,
                    status_code: enrolledResponseData.responseCode,
                })
            );
        }
        else {
            yield put(
                onEnrolledError({
                    enrolledData: enrolledResponseData.response,
                })
            );
        }
    } catch (error) {
        const message = error.message || "Something went wrong";
        yield put(onEnrolledError({ enrolledData: {}, message, }));
    }
}
export default function* validateLoginTokenSaga() {
    yield takeLatest(onValidateLoginTokenSubmit.type, validateLoginToken);
    yield takeLatest(onEnrolledSubmit.type, Enrolled);
}
